import type { Flow } from "@flow";
import CardOverview from "./card";
import { CleanupOverview } from "./cleanup";
import { LoanOverview } from "./loan";
import { Psd2CleanupOverview } from "./psd2-cleanup";
import RefundOverview from "./refund";

const ProcessOverview = (flow: Flow) => {
  if (
    flow.flowDefinitionId === "loan-es" ||
    (flow.flowDefinitionId === "common-process" &&
      (flow.caseData.referenceId?.toLowerCase().includes("loan-se") ||
        flow.caseData.referenceId?.toLowerCase().includes("loan-no") ||
        flow.caseData.referenceId?.toLowerCase().includes("loan-fi")))
  ) {
    return LoanOverview(flow);
  }

  if (
    flow.flowDefinitionId === "common-process" &&
    flow.caseData.referenceId?.toLowerCase().includes("card-se")
  ) {
    return CardOverview(flow);
  }

  if (
    flow.flowDefinitionId === "cleanup" ||
    flow.flowDefinitionId === "manual-cleanup"
  ) {
    return CleanupOverview(flow);
  }

  if (flow.flowDefinitionId === "psd2-cleanup") {
    return Psd2CleanupOverview(flow);
  }

  if (flow.flowDefinitionId === "refund") {
    return RefundOverview(flow);
  }

  return `The "${flow.flowDefinitionId}" process is missing a dedicated component in src/components/overviewTab folder.`;
};

export default ProcessOverview;
